<script>
  export let workout_plan
  export let id

  import { fetchO, patchO, postO } from '../oauth.js'

  import UserShort from '../components/UserShort.svelte'
  import UserSearchAndRoleSelection from '../components/UserSearchAndRoleSelection.svelte'

  let sharings
  async function fetchSharings() {
    const response = await fetchO(workout_plan.url + 'sharings/', {
      method: 'GET',
    })

    sharings = (await response.json())['results']
  }
  fetchSharings()

  async function updateSharing(id, role) {
    console.log('Should set sharing ' + id + ' to ' + role)

    const response = await patchO(workout_plan.url + 'sharings/' + id + '/', {
      role: role,
    })
    console.log('Response', response)

    fetchSharings()
  }

  async function removeSharing(id) {
    console.log('Should remove sharing ' + id)

    const response = await fetchO(workout_plan.url + 'sharings/' + id + '/', {
      method: 'DELETE',
    })
    console.log('Response', response)

    fetchSharings()
  }

  async function addSharing(event) {
    console.log('Should add sharing ', event.detail)

    const response = await postO(workout_plan.url + 'sharings/', {
      role: event.detail.role,
      user: event.detail.user.url,
    })
    console.log('Response', response)

    fetchSharings()
  }

  function getRoleLabel(role) {
    if (role == 'viewer') {
      return 'Viewer'
    } else if (role == 'editor') {
      return 'Editor'
    }
  }

  async function getUserForEmail(email) {
    const response = await fetchO(
      '/users/?email=' + encodeURIComponent(email),
      {
        method: 'GET',
      }
    )

    console.log('Response is', response)
    if (response.status == 200) {
      return await response.json()
    } else {
      return undefined
    }
  }

  const roles = ['viewer', 'editor']
</script>

<div
  class="modal fade"
  {id}
  tabindex="-1"
  aria-labelledby={id + '_label'}
  aria-hidden="true"
>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id={id + '_label'}>Share Plan</h5>
      </div>
      <div class="modal-body">
        {#if sharings}
          <ul class="list-group">
            <li
              class="list-group-item d-flex justify-content-between align-items-center"
            >
              <UserSearchAndRoleSelection
                {roles}
                {getRoleLabel}
                getUser={getUserForEmail}
                on:chooseUser={addSharing}
              />
            </li>
            {#each sharings as sharing (sharing.id)}
              <li
                class="list-group-item d-flex justify-content-between align-items-center"
              >
                <div class="me-auto"><UserShort user={sharing.user} /></div>
                <div class="dropdown">
                  <button
                    class="btn btn-secondary dropdown-toggle"
                    type="button"
                    id="dropdownMenuButton1"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    {getRoleLabel(sharing.role)}
                  </button>
                  <ul
                    class="dropdown-menu"
                    aria-labelledby="dropdownMenuButton1"
                  >
                    {#each roles as role}
                      <li>
                        <button
                          class="dropdown-item"
                          on:click={() => updateSharing(sharing.id, role)}
                          >{getRoleLabel(role)}</button
                        >
                      </li>
                    {/each}
                    <li><hr class="dropdown-divider" /></li>
                    <li>
                      <button
                        class="dropdown-item"
                        on:click={() => removeSharing(sharing.id)}
                        >Remove</button
                      >
                    </li>
                  </ul>
                </div>
              </li>
            {/each}
          </ul>
        {:else}
          <div class="spinner-border" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        {/if}
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary" data-bs-dismiss="modal"
          >Done</button
        >
      </div>
    </div>
  </div>
</div>
